export default (html, data) => {
    return html.html('<img src="' + data.src + '">');
}